import { useSuspenseQuery } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";

import { Section, SectionHeader } from "@roqua/components/sections";

import { PageTitle } from "@/components/PageTitle";
import { ProtocolSubscriptionList } from "@/features/ProtocolSubscriptions/ProtocolSubscriptionList";
import { StoppedProtocolSubscriptionsQuery } from "@/features/ProtocolSubscriptions/StoppedProtocolSubscriptionsQuery";
import { useTranslation } from "@/i18n/client";
import { useSessionContext } from "@/session";

export const Route = createFileRoute("/$organizationKey/$dossierId/protocol_subscriptions/stopped")(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  const { dossierId } = useSessionContext();
  const { t } = useTranslation("ProtocolSubscriptions");
  const { data } = useSuspenseQuery(StoppedProtocolSubscriptionsQuery, {
    variables: { dossierId },
  });
  const stoppedSubscriptions = data.dossier.stoppedProtocolSubscriptions.nodes;

  return (
    <>
      <PageTitle title="protocolSubscriptionsStopped" />
      {stoppedSubscriptions.length > 0 && (
        <Section variant="content">
          <SectionHeader header={t("stoppedSubscriptions")} />
          <ProtocolSubscriptionList protocolSubscriptions={stoppedSubscriptions} />
        </Section>
      )}
    </>
  );
}
